/** Значение-маркер «нет оценок» у метрик рейтинга. */
export const NO_RATING_VALUE = -999

/** ID основного типа ЛПУ «Лаборатория (анализы)». */
export const LABORATORY_LPU_TYPE_ID = 1 as const

export const DOCTORS_ICON_SRC = '/static/_v1/pd/icons/branding/lpu/rating/doctors.svg'
export const CLINIC_ICON_SRC = '/static/_v1/pd/icons/branding/lpu/rating/clinic.svg'
